import { ScriptSureControllerApi } from "@/services";
import { getConfigObject, useMutationWithLoading } from "@/utils/utils";

export interface SyncScriptsurePatientProps {
  patientId: string;
  xTENANTID: string;
}

/** Registers an already existing patient in ScriptSure. */
export const useSyncScriptsurePatient = () =>
  useMutationWithLoading(
    ({ patientId, xTENANTID }: SyncScriptsurePatientProps) =>
      new ScriptSureControllerApi(getConfigObject()).syncPatient(
        patientId,
        xTENANTID
      )
  );
